<div class="d-flex flex-row align-items-center modal-header-icon-container dialog-gap fw-bold">
  <i class="fs-4 pi pi-info-circle"></i>
  <h5 class="m-0 bold">MI Quote Results</h5>
</div>

<div [formGroup]="miQuoteResultForm">
  <div>
    <div class="row">
      <div class="d-flex align-items-center surface-border surface-overlay w-100">
        <p class="my-0">The Information below is used for the quote only. It is not saved to the loan file unless you accept a quote.</p>
      </div>
    </div>
    <br />
    <div class="row">
      <p-table [value]="selectedCompanies" [(selection)]="selectedCompany" dataKey="miVendor" class="stack">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 4rem"></th>
            <th>Company</th>
            <th style="width: 45%">Description</th>
            <th>UFMIP</th>
            <th>Monthly</th>
            <th>Renewal</th>
            <th>Coverage</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-company>
          <tr>
            <td>
              <p-tableRadioButton [value]="company" [disabled]="company?.errors?.length > 0" />
            </td>
            <td>
              <img
                style="display: block"
                width="100%"
                height="100%"
                [src]="'../../../../assets/images/' + company.miVendorName.replace(' ', '') + '.png'"
                [alt]="a"
                width="100"
              />
            </td>
            <td>
              @if (company.errors?.length > 0) {
                <div class="message-error-text">
                  <div class="d-flex justify-content-between">
                    <div>
                      {{ company.expandErrors ? company.errors.toString() : truncateEllipses(company.errors.toString(), errorDisplayMaxLength) }}
                    </div>
                    <div>
                      @if (!company.expandErrors && company.errors.toString().length > errorDisplayMaxLength) {
                        <i class="pi pi-angle-down expand-icon" (click)="company.expandErrors = !company.expandErrors"></i>
                      }
                      @if (company.expandErrors) {
                        <i class="pi pi-angle-up expand-icon" (click)="company.expandErrors = !company.expandErrors"></i>
                      }
                    </div>
                  </div>
                </div>
              }

              <div>
                {{ company.description }}
              </div>
            </td>
            <td>{{ !(company.errors?.length > 0) ? company.mipffPerc : '' }}</td>
            <td>{{ !(company.errors?.length > 0) ? company.miMoPremPerc : '' }}</td>
            <td>{{ !(company.errors?.length > 0) ? company.miMoPremPerc2 : '' }}</td>
            <td>{{ !(company.errors?.length > 0) ? company.miCoveragePercent : '' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="dialog-button-container">
      <button pButton type="button" severity="secondary" #closebutton data-dismiss="modal" class="mx-1" (click)="cancel()">Cancel</button>
      <button pButton type="button" [disabled]="emptyResult || !selectedCompany" class="mx-1" (click)="save()">Accept Quote</button>
    </div>
  </div>
</div>

@if (isLoading$ | async) {
  <cmg-clear2-ui-busy-indicator class="dialog" [loadingMessage]="loadingMessage$ | async" />
}
